import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import StateSelect from 'library/components/form-elements/state';
import CountrySelect from 'library/components/form-elements/country';
import LabelInput from 'library/components/unstyled-input';

import 'apps/pathways/styles/start/main.scss';

class ContactInfo extends React.PureComponent {
  render() {
    const { onChange, data, lastInputFocus } = this.props;

    return (
      <div className="experiences-form-container">
        <section>
          <label htmlFor="phone_type">
            Phone Number Type
            <select
              aria-label="phone_type"
              aria-required="true"
              onChange={onChange}
              value={resolve(data, 'phone_type', '')}
              name="phone_type"
              id="phone_type"
            >
              <option value="">--Select One--</option>
              <option value="home">Home</option>
              <option value="mobile">Mobile</option>
              <option value="work">Work</option>
            </select>
          </label>

          <LabelInput
            label="Phone Number"
            name="phone"
            type="input"
            onChange={onChange}
            placeholder="Phone Number"
            value={resolve(data, 'phone', '')}
          />
        </section>

        <section>
          <LabelInput
            label="Address"
            name="street"
            type="input"
            onChange={onChange}
            placeholder="Address"
            value={resolve(data, 'street', '')}
          />

          <LabelInput
            diffAriaLabel="Address (continued)"
            label="Address (continued)"
            name="street_2"
            type="input"
            onChange={onChange}
            placeholder="Address (continued)"
            value={resolve(data, 'street_2', '')}
          />
        </section>

        <section>
          <LabelInput
            label="City"
            name="city"
            type="input"
            onChange={onChange}
            placeholder="City"
            value={resolve(data, 'city', '')}
          />

          <label htmlFor="state">
            State
            <StateSelect
              name="state"
              aria-label="state"
              aria-required="true"
              onChange={onChange}
              value={resolve(data, 'state', '')}
              id="name"
            />
          </label>
        </section>

        <section>
          <LabelInput
            label="Postal Code"
            name="zipcode"
            type="input"
            onChange={onChange}
            placeholder="Postal Code"
            value={resolve(data, 'zipcode', '')}
          />

          <label htmlFor="country">
            Country
            <CountrySelect
              onFocus={() => lastInputFocus()}
              name="country"
              aria-label="country"
              aria-required="true"
              onChange={onChange}
              value={resolve(data, 'country', '')}
              id="country"
            />
          </label>
        </section>
      </div>
    );
  }
}

ContactInfo.propTypes = {
  onChange: PropTypes.object,
  data: PropTypes.object,
  lastInputFocus: PropTypes.func,
};

export default ContactInfo;
